import React from 'react';
import { HomeIcon, CreditCardIcon, UsersIcon, UserIcon, SettingsIcon, LinkIcon, WalletIcon, TrendingDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface NavigationProps {
  currentView: string;
  setCurrentView: (view: string) => void;
}
export function Navigation({
  currentView,
  setCurrentView
}: NavigationProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: HomeIcon,
    path: '/'
  }, {
    id: 'cards',
    label: 'Cards',
    icon: CreditCardIcon,
    path: '/'
  }, {
    id: 'income',
    label: 'Income Management',
    icon: WalletIcon,
    path: '/income'
  }, {
    id: 'debt-management',
    label: 'Debt Management',
    icon: TrendingDownIcon,
    path: '/debt-management'
  }, {
    id: 'social',
    label: 'Social',
    icon: UsersIcon,
    path: '/'
  }, {
    id: 'profile',
    label: 'Profile',
    icon: UserIcon,
    path: '/'
  }, {
    id: 'linked-accounts',
    label: 'Open Banking',
    icon: LinkIcon,
    path: '/linked-accounts'
  }, {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    path: '/'
  }];
  return <nav className="bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 md:w-64 flex-shrink-0 transition-colors duration-200" data-id="element-519">
      <div className="md:hidden p-4 flex justify-between border-b border-gray-200 dark:border-gray-700" data-id="element-520">
        {navItems.map(item => <Link key={item.id} to={item.path} onClick={() => setCurrentView(item.id)} className={`p-2 rounded-full ${currentView === item.id ? 'bg-primary text-white' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`} data-id="element-521">
            <item.icon className="w-5 h-5" data-id="element-522" />
          </Link>)}
      </div>
      <div className="hidden md:block" data-id="element-523">
        <ul className="py-4" data-id="element-524">
          {navItems.map(item => <li key={item.id} data-id="element-525">
              {item.id === 'openbanking' || item.id === 'income' || item.id === 'linked-accounts' || item.id === 'debt-management' ? <Link to={item.path} className={`w-full flex items-center space-x-3 px-6 py-3 text-left ${currentView === item.id ? 'bg-gradient-to-r from-primary/10 to-secondary/10 text-primary dark:text-primary border-r-4 border-primary' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`} onClick={() => setCurrentView(item.id)} data-id="element-526">
                  <item.icon className="w-5 h-5" data-id="element-527" />
                  <span data-id="element-528">{item.label}</span>
                </Link> : <button onClick={() => setCurrentView(item.id)} className={`w-full flex items-center space-x-3 px-6 py-3 text-left ${currentView === item.id ? 'bg-gradient-to-r from-primary/10 to-secondary/10 text-primary dark:text-primary border-r-4 border-primary' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`} data-id="element-529">
                  <item.icon className="w-5 h-5" data-id="element-530" />
                  <span data-id="element-531">{item.label}</span>
                </button>}
            </li>)}
        </ul>
      </div>
    </nav>;
}